import React from 'react';
import { CustomerWelcomeMessage } from '@thd-olt-component-react/customer-welcome-message';
import { AUTHORIZATION_STATUS } from '../utils';

export function CustomRenderedWelcomeMessage({ userAuthStatus }) {
  return function WelcomeMessage() {
    return (
      <CustomerWelcomeMessage
        isCustomerAuthenticated={
          userAuthStatus === AUTHORIZATION_STATUS.AUTHENTICATED
        }
      />
    );
  };
}
